import React from "react";
import ServicesPage from "../components/servicesPage";

const Services = () => {
    return (
        <ServicesPage />
    )
}

export default Services;